import { type FunctionComponent } from 'react';

type CategoryBrowsePageProps = {
	title: string;
};

export const CategoryTitle: FunctionComponent<CategoryBrowsePageProps> = ({ title }) => {
	return (
		<div className={'flex flex-wrap justify-between-l'}>
			<div className={'w-100 w-auto-ns'}>
				<h1 className={'dib ma0'}>{title}</h1>
			</div>
		</div>
	);
};
